@if (isEpcotEnabled) {
    <span class="theme-info-i"></span>
}
<div class="rewards-not-eligible-message" [innerHtml]="message | msTrust: 'html'"></div>
